// extracted by mini-css-extract-plugin
export default {"campaignPoster":"CampaignPoster_campaignPoster__Jbp1-","left":"CampaignPoster_left__wXWcE","right":"CampaignPoster_right__uvMjk","campaignBtn":"CampaignPoster_campaignBtn__3DqNe"};